const Truncate = ({ length, children }) => {
  const truncatedString = children.substr(0, children.lastIndexOf(' ', length));
  return children.length > length ? `${truncatedString}...` : children;
};

export default Truncate;
